import type { CustomTranslateKey } from '@/basket/types/i18n';
import type { ErrorMessageData } from '@/extensions/yup';
import { useTranslations } from 'next-intl';

export const useErrorMessageTranslator = () => {
  const t = useTranslations('common.error');

  return (errorMessage: string | ErrorMessageData | undefined) => {
    if (!errorMessage) return undefined;

    if (typeof errorMessage === 'string') {
      return errorMessage;
    }

    const params: Record<string, unknown> = {};
    if (errorMessage.min !== undefined) params.min = errorMessage.min;
    if (errorMessage.max !== undefined) params.max = errorMessage.max;

    return t(errorMessage.translationKey as CustomTranslateKey, params as any);
  };
};
